const GoogleMaps = require('./../../../../global/js/modules/google-maps');
const VueUtils = require('./../../modules/vue-utils');



let $bookingApp, $vehicleFilter, $vehicleResults;

//ignore initial search, as we pre-init with the full vehicle list from the location
let ignoredInitialSearch = false;

function _setupForVueApp() {
    $vehicleFilter = document.querySelector('.v-app[data-ref="vehicle-type-filter"]');
    $vehicleResults = document.querySelector('.v-app[data-ref="vehicle-results"]');

    if (!$vehicleFilter || !$vehicleResults) {
        console.warn('Filter or results components not found');
        return;
    }

    const resultsContainer = VueUtils.getRef('vehicle-results');
    const searchContainer = VueUtils.getRef('vehicle-type-filter');

    resultsContainer.canSubmit = false;

    $bookingApp.addEventListener('vehicle-type-filter:search-started', event => {
        resultsContainer.setBusy(event.detail && event.detail.message ? event.detail.message : true);
        if (!(event.detail && event.detail.partial)) {
            resultsContainer.setResults(null);
        }
    });


    $bookingApp.addEventListener('vehicle-type-filter:search-completed', event => {
        resultsContainer.setBusy(false);

        if (!ignoredInitialSearch) {
            if (!searchContainer.selectedValues.fromDate || !searchContainer.selectedValues.toDate) {
                return;
            }

            ignoredInitialSearch = true;
        }

        resultsContainer.canSubmit = true;
        resultsContainer.setResults(event.detail);
    });
}


document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('html.location')) {
        return;
    }

    let $mapElement = document.querySelector('#location-map'),
        $coordinateElement = $mapElement ? $mapElement.querySelector('[type="text/gps-coordinates"]') : null
    ;

    if (!$mapElement || !$coordinateElement) {
        return;
    }

    let markers = [];

    const coordinate = JSON.parse($coordinateElement.innerText);

    if (!coordinate) {
        return;
    }

    GoogleMaps.insertMap($mapElement, {
        center: coordinate,
        zoom: 17
    }).then((map) => {
        $coordinateElement._marker = new google.maps.Marker({
            position: coordinate,
            map: map
        });

        $coordinateElement._marker.setMap(map);
        markers.push($coordinateElement._marker);
    });

    $bookingApp = document.querySelector('#layout-content');

    if (!$bookingApp) {
        return;
    }

    // _setupForVueApp();
});




